import { render, staticRenderFns } from "./ManageRealEstates.vue?vue&type=template&id=267ddb3c&"
import script from "./ManageRealEstates.vue?vue&type=script&lang=js&"
export * from "./ManageRealEstates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports